import styled from 'styled-components'
import { UserProfile } from '../../libs/profile-service'

interface Props {
    profileData?: UserProfile | null
}

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: left;
    flex-direction: column;
    justify-content: left;
    font-size: 24px;
`

export default function Security({ profileData }: Props) {
    return (
        <Wrapper>
            <div>
                <p>Password</p>
                <input type="text" />
            </div>
            <div>
                <button>Save Changes</button>
            </div>
        </Wrapper>
    )
}
